import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Container, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { Formik } from 'formik'
import React from 'react'
import { MeasurementsFormData } from '../../models/measurements'
import MeasurementsForm from './MeasurementsForm'
import { FormStepProps } from 'src/Libs/installation-statement/components/types'
import useMeasurementsValidation from 'src/Libs/installation-statement/hooks/validation/use-measurements-validation'

const useStyles = makeStyles()(theme => ({
  container: {
    padding: 0,
  },
  requiredStyle: {
    display: 'flex',
    justifyContent: 'end',
    marginTop: theme.spacing(2),
  },
}))

/**
 * Component for the installation statement wizard measurements step
 */
const Measurements: React.FC<FormStepProps<MeasurementsFormData>> = ({ data, setFormData, setFinalValidation, setTouched }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const { inProgressValidationSchema, finalValidationSchema } = useMeasurementsValidation()

  const handleValidationForFinalValidationSchema = async (values: MeasurementsFormData): Promise<void> => {
    const response = await finalValidationSchema.isValid(values)
    setFinalValidation(response)
  }

  return (
    <Container className={classes.container}>
      <Typography variant="h4">{t('installation-statement.measurement.title')}</Typography>
      {/*eslint-disable-next-line @typescript-eslint/no-empty-function*/}
      <Formik initialValues={data} onSubmit={() => {}} validationSchema={inProgressValidationSchema}>
        {formData => {
          if (formData.dirty) {
            setTouched(true)
          }

          setFormData(formData)

          handleValidationForFinalValidationSchema(formData.values)
          return <MeasurementsForm />
        }}
      </Formik>
      <Typography variant="caption" className={classes.requiredStyle}>
        {`*${t('common.required')}`}
      </Typography>
    </Container>
  )
}

export default Measurements
